import { Ticker, UPDATE_PRIORITY } from 'pixi.js';
var minInterval = 40;
var getNewTicker = function () {
    var ticker = new Ticker();
    ticker.autoStart = true;
    return ticker;
};
export var createTickerManager = function (updateFn, getTickerInterval, ticker) {
    if (ticker === void 0) { ticker = getNewTicker(); }
    var isConnectedToTicker = false;
    var deltaMsSum = 0;
    var finalUpdateFn = function (deltaTime) {
        var deltaMs = deltaTime / 60 * 1000;
        var tickerInterval = getTickerInterval();
        // if interval too low do not delay update
        if (tickerInterval < minInterval) {
            return updateFn(deltaMs);
        }
        deltaMsSum += deltaMs;
        // delay update according interval
        if (deltaMsSum < tickerInterval) {
            return;
        }
        deltaMs = deltaMsSum;
        deltaMsSum = 0;
        return updateFn(deltaMs);
    };
    return {
        start: function () {
            if (!isConnectedToTicker) {
                ticker.add(finalUpdateFn, undefined, UPDATE_PRIORITY.LOW);
                isConnectedToTicker = true;
            }
        },
        stop: function () {
            if (isConnectedToTicker) {
                ticker.remove(finalUpdateFn);
                isConnectedToTicker = false;
            }
        },
        isRunning: function () { return isConnectedToTicker; },
        resetDeltaMsSum: function () {
            deltaMsSum = 0;
        }
    };
};
